import { SYSTEM, WALLET, MARKET, USER_MARKET, USER, CRYPTO_PRICE } from 'socket-resources/namespaces/index'

export const WALLET_USER_WALLET_BALANCE = `${WALLET}/userWalletBalance`
export const SYSTEM_GAME_SETTINGS_UPDATE = `${SYSTEM}/gameSettings`
export const MARKET_ACTIVITY_COMMENTS = `${MARKET}/comments`
export const MARKET_ACTIVITY = `${MARKET}/activity`
export const MARKET_OPTION = `${MARKET}/option`

export const USER_MARKET_USER_POSITION = `${USER_MARKET}/userPosition`
export const USER_ACTIVITY = `${USER}/activity`
export const CRYPTO_PRICE_TICK = `${CRYPTO_PRICE}/tick`
